import { FC } from "react"
import { TSlotSection } from "widgets/allSlotsModal/types"
import { Section, SectionHead, SectionIcon } from "../styles"
import { Flex } from "shared/ui/flex"
import { BookingSlot } from "features/booking/slots/ui/components/BookingSlot"
import { BookingTime } from "entities/toolbar/timeslots"

type AllSlotsModalSectionProps = {
  section: TSlotSection;
  currentSlot: string;
  changeSlot: (bookingTime: BookingTime) => void;
}

export const AllSlotsModalSection: FC<AllSlotsModalSectionProps> = ({
  section,
  currentSlot,
  changeSlot
}) => {
  return (
    <Section $isActive={section.isActive}>
      <SectionHead>
        <SectionIcon src={section.icon} />
        <span>{section.name} {section.time}</span>
      </SectionHead>
      <Flex $wrap="wrap" $gap="8px">
        {section.timeslots.map((timeslot, index) => {
          return (
            <BookingSlot 
              key={index}
              currentSlot={currentSlot}
              disabledSlot={null}
              bookingTime={timeslot}
              activeSlot={changeSlot}
              changeSlotsLabelText={() => null}
            />
          )
        })}
      </Flex>
    </Section>
  )
}